// TOP LEVEL IMPORTS
import React from 'react';
//
import Icon from 'components/common/Icon';

const Result = ({
  type, title, description, extra, actions,
}) => {
  const iconMap = {
    error: <Icon className="error" type="close-circle" style={{ fontSie: 50 }} />,
    success: <Icon className="success" type="check-circle" style={{ fontSie: 50 }} />,
  };

  return (
    <div className="result" style={{ textAlign: 'center' }}>
      <div className="icon">{iconMap[type]}</div>
      <div className="title">{title}</div>
      {description && <div className="description">{description}</div>}
      {extra && <div className="extra">{extra}</div>}
      {actions && <div className="actions">{actions}</div>}
    </div>
  );
};

export default Result;



// WEBPACK FOOTER //
// ./src/components/common/Result/index.js